import { CCard, CCardBody } from '@coreui/react'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import "./style.scss"
import { tenantType } from '../../../../../service/types/authTypes/loginTypes'
import authService from '../../../../../service/reactQueryServices/services/authService'
import { useMutation } from 'react-query'
import { setLoginLocalStorageProps } from '../../../../../components/helper'
import CustomValuesHook from '../../../../../Hooks/customValuesHook'
import { Trans, useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { setUserInfo } from '../../../../../service/actions/userActions'
import { initialAxiosInstance } from '../../../../../service/apiCall'


const Instance = () => {
  const location = useLocation()
  const { mutateAsync: loginTenant, isLoading: loginTenantLoading } = useMutation("postLoginTenant", authService.postLoginTenant);
  const [localState, setLocalState] = CustomValuesHook({ selectedTenant: "" })
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch()

  const handleSelectTenant = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    setLocalState({ tenantId: e.target.value })

  }

  const tenantLogin = async () => {
    try {
      const loginTenantResponse = await loginTenant(localState.tenantId)
      setLoginLocalStorageProps(loginTenantResponse).then((result) => {
        // window.location.href = "/#/dashboard"
        dispatch(setUserInfo({
          sipOnlineUser: result,
          userMenu: loginTenantResponse.jsonMenu,
          accessToken: loginTenantResponse.token,
          multiTenants: location.state.tenants
        }))
        // window.location.href = "/#/dashboard"
        initialAxiosInstance(loginTenantResponse.token, i18n.language, loginTenantResponse.tenants[0].tenantId)
        navigate("/dashboard")


      })

    } catch (error) {
      console.log(error)

    }
  }



  return (
    <div className='form-container instance-container'>

      <CCard className='form-cantainer-card full-window-height'>
        <CCardBody className="team-member-wrapper" >
          <div className='des-context'>
            <div>
              {/* {t("DESCRIPTION.INSTANCE_LOGIN_1", { email: location?.state?.email })} */}
              <Trans
                i18nKey="DESCRIPTION.INSTANCE_LOGIN_1"
                values={{ email: location?.state?.email }}
                components={{ bold: <b /> }}
              />

            </div>
            <p>
              {t("DESCRIPTION.INSTANCE_LOGIN_2")}
            </p>
          </div>

          <div className='instance-selector' >
            <div>
              <label>{t("TITLES.WHICH_ACCOUNT_DO_YOU_LOGIN")}</label>
              <select className='form-select' value={localState.tenantId} onChange={handleSelectTenant}>
                <option>--{t("OPTIONS.SELECT_AN_OPTION")}---</option>
                {location.state.tenants.sort((a: any, b: any) => (b.isOwner - a.isOwner)).map((tenant: tenantType, idx: number) => <option key={idx} value={tenant.tenantId}>
                  {`${tenant.isOwner ? t("TITLES.MYSELF") : t("TITLES.MEMBER_IN_ACCOUNT")} ${tenant.fullName}`}
                  {/* {location?.state?.email} */}
                </option>)}


              </select>
              <button
                className='btn btn-primary w-100 mt-5'
                disabled={!localState.tenantId}
                onClick={tenantLogin} >{t("ACTIONS.PORTAL_ENTERING")}</button>
            </div>

          </div>

        </CCardBody>
      </CCard>

    </div>
  )
}

export default Instance